import React, { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import { ButtonGroup, LinkButton, StandardButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { useClick2PayProfile } from '@/react-query/hooks/query/use-click2pay';
import { useClick2PayIsAllowed } from '@/react-query/hooks/useClick2PayIsAllowed';

import useText from '@hooks/use-text';
import Click2PayVisaLogo from '@pages/click2pay/click2pay-visa.svg';
import { getClick2PayUrl } from '@pages/click2pay/functions';
import click2PayRoutes from '@pages/click2pay/routes';

import Click2PayLogo from '../click2pay.svg';

const Click2PayInfoContent = () => {
    const { click2PayNext, click2PayCancel } = useText();
    const navigate = useNavigate();
    const [queryParams] = useSearchParams();
    const { termsAndConditions, admin } = click2PayRoutes;
    const profile = useClick2PayProfile();
    const click2PayIsAllowed = useClick2PayIsAllowed();

    useEffect(() => {
        if (!click2PayIsAllowed) {
            navigate('/');
        }
    }, [click2PayIsAllowed, navigate]);

    const next = () => {
        if (profile.data && !!profile.data?.customerProfile) {
            return navigate(getClick2PayUrl(queryParams, admin));
        }
        return navigate(getClick2PayUrl(queryParams, termsAndConditions));
    };

    return (
        <InfoCard skipBackground className="click2pay-info-card">
            <RichIcon type={RichIconTypes.DIGITALTKORT_ABONNEMENT} />
            <h3>Click to Pay gjør det enda enklere å betale kontaktløst på nett</h3>
            <p>
                Hver gang du ser denne logoen
                <img className="click2pay-inline-logo" src={Click2PayLogo} alt="click2pay logo" /> i nettbutikken,
                trenger du kun e-posten din for å betale, så slipper du å skrive inn alt for hånd.
            </p>
            <p>
                Kortdetaljene dine er trygt ivaretatt i Click to Pay av Visa – en av verdens mest betrodde merkevarer.
            </p>
            <img className="click2pay-visa-logo" src={Click2PayVisaLogo} alt="click2pay visa logo" />

            <ButtonGroup
                primaryAction={
                    <StandardButton onClick={next} disabled={profile.isPending}>
                        {click2PayNext}
                    </StandardButton>
                }
                tertiaryAction={<LinkButton onClick={() => navigate('/')}>{click2PayCancel}</LinkButton>}
            />
        </InfoCard>
    );
};

export default Click2PayInfoContent;
